// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subcolumn .el-menu-item-group__title {\n  display: none;\n}\n.subcolumn .el-menu-item {\n  height: 0.223958rem !important;\n  line-height: 0.223958rem !important;\n}", ""]);
// Exports
module.exports = exports;
